import { authorizedAction, ErrorProp } from 'api'
import { DeviceType } from 'types'

type SendInstructionsResponseProps =
  | {
      success: true
    }
  | {
      success: false
      error: ErrorProp
      message?: string
    }

export type SendInstructionsProps = {
  userId: string
  device?: DeviceType
}

export async function sendInstructions({
  userId,
  device,
}: SendInstructionsProps): Promise<SendInstructionsResponseProps> {
  try {
    const response = await authorizedAction({
      action: 'Student.SendInstructions',
      body: {
        Username: userId,
        Device: device,
      },
    })

    const json = (await response.json()) as SendInstructionsResponseProps

    if (json.success) {
      return { success: true }
    } else {
      return {
        success: false,
        error: json.error ?? json.message,
      }
    }
  } catch (e: any) {
    throw e
  }
}
